query GetDafStatementPeriods {
  dafStatementPeriods {
    period
    startDate
    endDate
    statuses {
      generationStatus
      count
    }
  }
}
